import React, { Component } from 'react';
import Big from 'big.js';
// import amountImage from 'assets/images/Bucket.png';
// import packageImage from 'assets/images/Trowel.png';
import styles from './styles';
import { css } from 'aphrodite';
import { Button, Title, Product } from '../../library';
// import ReactToPrint from 'react-to-print';

class Calculation extends Component {

    constructor(props) {
        super(props);
        this.state = {
            isPackagingError: false,
            isImperialSystem: props.isImperialSystem,
            cartridgeQuantity: props.cartridgeQuantity,
            isReady: props.isReady,
            product: props.selectedProduct,
            jointDimensions: props.jointDimensions,
            jobType: props.jobType,
            totalLength: props.totalLength,
            productWeight: null,
            productPackage: [],
            showResult: props.showResult,
            BreakdownProductName: props.BreakdownProductName,
            BreakdownRatio: props.BreakdownRatio,
            // isResult: false,
            finalProductQuantity: null,
            backerRodPackage: null,
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if(prevProps.isImperialSystem !== this.props.isImperialSystem) {
            this.setState({isImperialSystem: this.props.isImperialSystem, isPackagingError: false});
        }
        if(prevProps.isReady !== this.props.isReady) {
            this.setState({isReady: this.props.isReady});
        }
        if(prevProps.product !== this.props.product) {
            this.setState({product: this.props.product});
        }
        if(prevProps.cartridgeQuantity !== this.props.cartridgeQuantity) {
            this.setState({cartridgeQuantity: this.props.cartridgeQuantity});
        }
        if(prevProps.jobType !== this.props.jobType) {
            this.setState({jobType: this.props.jobType});
        }
        if(prevProps.totalLength !== this.props.totalLength) {
            this.setState({totalLength: this.props.totalLength});
        }
        if(prevProps.area !== this.props.area) {
            this.setState({area: this.props.area});
        }
        if(prevProps.jointDimensions !== this.props.jointDimensions) {
            this.setState({jointDimensions: this.props.jointDimensions});
        }
        if(prevProps.showResult !== this.props.showResult) {
            this.setState({showResult: this.props.showResult});
        }
    }

    onShowResult(){
        this.props.onShowResult();
    }

    handleDoCalculation(e) {
        e.preventDefault();

        const { dataLayer } = this.props;

        if(this.state.isReady) {
            // let packaging = this.state.product.fieldPackagingSealant.entity.name;
            let packaging = this.state.cartridgeQuantity.fieldQuantity;
            let { jointWidth, jointDepth } = this.state.jointDimensions;
            let jobType = this.state.jobType;

            let totalLength;
            if(this.state.isImperialSystem) {
                // TO CHANGE
                // Convert total length from feet to millimeters (1ft = 12in; 1in = 25.4mm)
                totalLength = new Big(this.state.totalLength.totalLength).times(new Big(304.8));
            } else {
                // Convert total length from meters to millimeters
                // totalLength = new Big(this.state.totalLength.totalLength).times(new Big(1000));

                // Convert total length from centimeters to millimeters
                totalLength = new Big(this.state.totalLength.totalLength).times(new Big(10));
            }
            // let totalLength = new Big(this.state.totalLength.totalLength).times(new Big(1000));

            if(this.state.isImperialSystem) {
                // Convert width and depth from inches to millimeters (1in = 25.4mm)
                jointWidth = Number(new Big(jointWidth).times(new Big(25.4)));
                jointDepth = Number(new Big(jointDepth).times(new Big(25.4)));
            }

            console.log('jointWidth', jointWidth)
            console.log('jointDepth', jointDepth)
            console.log('totalLength', Number(totalLength))

            console.log('packaging', packaging)

            let jobTypeRatio;
            jobType === 'triangle' ? jobTypeRatio = 2 : jobTypeRatio = 1;
            console.log('jobType', jobType)
            console.log('jobTypeRatio', jobTypeRatio)

            let totalQuantity = new Big(jointWidth).times(new Big(jointDepth)).times(new Big(totalLength)).div(new Big(jobTypeRatio)).div(new Big(1000000));
            console.log('totalQuantity', Number(totalQuantity));

            let packagingInLiters = new Big(packaging).div(new Big(1000));
            if(this.state.isImperialSystem) {
                // Convert packaging weight from ounces to milliliters (1oz = 29.5735ml)
                // Convert milliliters to liters
                packagingInLiters = new Big(packaging).times(new Big(29.5735)).div(new Big(1000));
            }

            let productQuantity = new Big(totalQuantity).div(new Big(packagingInLiters));
            console.log('productQuantity', Number(productQuantity));

            let productQuantityAddLoss;
            if (jobType === 'triangle') {
                // [Ticket 39412] add 15% instead of 10% loss if triangle joint
                productQuantityAddLoss = new Big(productQuantity).times(new Big(1.15)) // add 15% to quantityPerLinearMeter
                console.log('add loss 15%', Number(productQuantityAddLoss));
            } else {
                productQuantityAddLoss = new Big(productQuantity).times(new Big(1.1)) // add 10% to quantityPerLinearMeter
                console.log('add loss 10%', Number(productQuantityAddLoss));
            }

            let productQuantityCeil = Math.ceil(Number(productQuantityAddLoss));
            console.log('productQuantityCeil', Number(productQuantityCeil));

            let finalProductQuantity = Math.ceil(Number(productQuantityAddLoss));

            console.log('finalProductQuantity', finalProductQuantity)

            let backerRod;
            let backerRodPackage = null;

            if (jobType === "square") {

                let backerRodsArray = [
                    6,
                    8,
                    10,
                    12,
                    15,
                    20,
                    25,
                    30,
                    40,
                    50,
                ]

                // Get imperial sizes
                if(this.state.isImperialSystem) {
                    let inchBy12 = 25.4 / 12;
                    let inchBy8 = 25.4 / 8;
                    backerRodsArray = [
                        inchBy12*3,
                        inchBy8*3,
                        inchBy12*6,
                        inchBy8*5,
                        inchBy12*9,
                        inchBy12*12,
                        inchBy12*15,
                        inchBy12*18,
                        inchBy12*24
                    ]
                }

                backerRod = new Big(jointWidth).times(1.5);
                backerRod = Math.ceil(Number(backerRod))

                for (let index = 0; index < backerRodsArray.length; index++) {
                    const element = backerRodsArray[index];

                    if (backerRod === backerRodsArray[0]) {
                        backerRodPackage = backerRodsArray[0]
                    } else if (element < backerRod) {
                        if (backerRodsArray[index + 1] ) {
                            backerRodPackage = backerRodsArray[index + 1]
                        } else {
                            backerRodPackage = element
                        }

                        // Convert to inches
                        if(this.state.isImperialSystem) {
                            backerRodPackage = backerRodPackage/25.4;
                        }
                    }
                }


                this.setState({backerRodPackage: backerRodPackage},()=>{
                    console.log(backerRodPackage)
                })
            }

            this.setState({showResult: true, finalProductQuantity: finalProductQuantity},()=>{
                this.onShowResult();
            })

            if (dataLayer !== null) {
                dataLayer.push({
                    'event' : 'GCresult',
                    'GCtype': this.state.product.title,
                    'GCresult' : finalProductQuantity,
                    'GCunit': packaging + (this.state.isImperialSystem ? 'oz' : 'ml')
                });

                console.log(dataLayer);
            }
        } else {
            this.props.onThrowError();
        }
    }

    render() {
        const {
            linkTitle,
            buttonLabel,
            title,
            // totalLabel,
            // packagedLabel,
            // orLabel,
            // printButtonLabel,
            // findDistributorButtonLabel,
            // findDistributorLink,
            legalParagraph,
            // ofLabel,
            inactiveButtonLabel,
            // printContainerRef,
            dataLayer,
            // locale,
            cartridgeLabel,
            backerRodPackagelabel,
            noBackerRodPackageLabel,
            titleCertificate,
            titleRelatedCleaners,
        } = this.props;

        return (
        <div className={css(styles.calculation)}>
            <div className={css(styles.buttonWrapper)}>
                <Button
                    text={buttonLabel}
                    link="#"
                    isPrimary
                    onClick={(e)=>this.handleDoCalculation(e)}
                    isActive={!this.state.showResult}
                    inactiveText={inactiveButtonLabel}
                    isCalculationButton
                    dataLayer={dataLayer}
                />
            </div>
            {this.state.showResult &&
            <div>
                <Title style={styles.title}>{title}</Title>
                <div className={css(styles.resultContainer)}>
                    <div className={css(styles.suggestionContainer)}>
                        <div className={css(styles.flexContainer)}>

                            {/* {this.state.productWeight &&
                            <div className={css(styles.totalWeightWrapper)}>
                                <div className={css(styles.totalWeight)}>{(Math.round(this.state.productWeight.toString() * 100) / 100).toLocaleString(locale)} {this.state.isImperialSystem ? "LBS" : "kg"}</div>
                                <div className={css(styles.productName)}>{ofLabel }  {this.state.product.entity.fieldBreakdownProductName ? this.state.product.entity.fieldBreakdownProductName : this.state.product.entity.entityLabel}</div>
                            </div>
                            } */}
                        </div>
                    </div>

                </div>
                <div className={css(styles.productResultWrapper)}>
                    <Product
                        data={this.state.product}
                        linkTitle={linkTitle}
                        dataLayer={dataLayer}
                        selectedProduct={this.state.product}
                        isResult={true}
                        finalProductQuantity={this.state.finalProductQuantity}
                        backerRodPackage={this.state.backerRodPackage}
                        backerRodPackagelabel={backerRodPackagelabel}
                        noBackerRodPackageLabel={noBackerRodPackageLabel}
                        jobType={this.state.jobType}
                        cartridgeLabel={cartridgeLabel}
                        cartridgeType={this.state.cartridgeQuantity.fieldPackagingType.entity.entityLabel}
                        isImperialSystem={this.state.isImperialSystem}
                        titleCertificate={titleCertificate}
                        titleRelatedCleaners={titleRelatedCleaners}
                        // packaging={this.state.product.fieldPackagingSealant.entity.name}
                        packaging={this.state.cartridgeQuantity.name}
                    />
                </div>
                {legalParagraph &&
                <div className={css(styles.legal, styles.legalResult)} dangerouslySetInnerHTML={{__html: legalParagraph}}></div>
                }

                <div className={css(styles.clearfix)}></div>
            </div>
            }
            {legalParagraph && !this.state.showResult &&
            <div className={css(styles.legal)} dangerouslySetInnerHTML={{__html: legalParagraph}}></div>
            }
        </div>
        );
    }
}

export default Calculation;
